export default __webpack_public_path__ + "static/media/aboutM.70ef5769.jpg";